/*
 |-----------------------------------------------------------------------------
 | components/molecules/Article/Article.tsx
 | v1.0.0
 |-----------------------------------------------------------------------------
 |
 | Some description...
 |
 */

import React from 'react';

import { get } from 'lodash';
// import { ray } from 'node-ray/web';
import classNames from 'classnames';

import * as IArticle from './types';

import Link from 'next/link';

import styles from './Article.module.scss';

const variants = {
	brand1: 'brand1',
	brand2: 'brand2',
	brand3: 'brand3',
	brand4: 'brand4',
};

const Article: React.FC<IArticle.IProps> = ({
	action,
	aos,
	className,
	path,
	title,
	variant,
}) => {
	const classes = classNames(
		get(styles, 'block'),
		get(styles, variants[variant]),
		className
	);

	// ray('Debug molecule Article:', {
	// 	aos: aos,
	// 	classname: classname,
	// 	path: path,
	// 	variant: variant,
	// }).blue();

	return (
		<article
			className={classes}
			data-aos={aos}
			itemScope
			itemType="http://schema.org/NewsArticle"
		>
			<Link href={path || '#'} passHref>
				<a
					className={get(styles, 'link')}
					href="jsx-a11y"
					itemProp="url"
				>
					<div className={get(styles, 'front')}>
						<svg className={get(styles, 'icon')} aria-hidden="true">
							<use xlinkHref="/imgs/icn_sprite.svg#megaphone"></use>
						</svg>

						{title && (
							<h3
								className={get(styles, 'title')}
								itemProp="headline"
							>
								{title}
							</h3>
						)}
					</div>
					<div className={get(styles, 'back')}>
						{action && (
							<p className={get(styles, 'action')}>{action}</p>
						)}
					</div>
				</a>
			</Link>
		</article>
	);
};

export default Article;
